var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import "../../Utilities.js";
import { CommandBar as CommandBar$1 } from "@fluentui/react/lib/CommandBar";
import "../Spinner/index.js";
import { Spinner } from "../Spinner/Spinner.js";
import { css } from "@fluentui/utilities";
const defaultClassName = "ane-CommandBar";
const CommandBar = (props) => {
  const _a = props, { className, overflowAriaLabel, loading, items } = _a, rest = __objRest(_a, ["className", "overflowAriaLabel", "loading", "items"]);
  let defaultItems = items;
  if (!!loading) {
    defaultItems = defaultItems.concat([
      {
        key: "loading",
        commandBarButtonAs: () => /* @__PURE__ */ jsx(
          Spinner,
          {
            styles: {
              root: {
                marginLeft: "7px",
                marginRight: "7px"
              }
            },
            ariaLabel: ""
          }
        ),
        renderedInOverflow: false
      }
    ]).map((item) => __spreadProps(__spreadValues({}, item), {
      disabled: true
    }));
  }
  return /* @__PURE__ */ jsx(
    CommandBar$1,
    __spreadProps(__spreadValues({}, rest), {
      items: defaultItems,
      className: css(defaultClassName, className),
      overflowButtonProps: { ariaLabel: overflowAriaLabel }
    })
  );
};
export {
  CommandBar,
  CommandBar as default
};
//# sourceMappingURL=CommandBar.js.map
